import { CapillaryRefillTime, Mm } from 'gql/types';

export default {
  PAGINATION: {
    DEFAULT_LIMIT: 10,
    PAGE_SIZE: 10,
    USER_SELECT_TAKE: 25,
    LOCATIONS_PAGE_SIZE: 100,
    BREEDS_PAGE_SIZE: 10,

    BATCH_SIZE: 5000,
  },

  UI: {
    DEBOUNCE_DELAY: 500,
    PHONE_NUMBER_MASK: '(999) 999-9999',
    WEEK_STARTS_ON: 1 as 0 | 1 | 3 | 2 | 4 | 5 | 6,
    MAX_ASSIGNED_LOCATIONS_TO_CLOSE_SECTION: 10,
  },

  DATE_FORMATS: {
    DATE: 'dd MMM yyyy',
    TIME: 'hh:mm a',
    DATE_AND_TIME: 'dd MMM yyyy HH:mm',
    LOCALIZED_TIME: 'p',
    SHORT_DATE: 'ddMMyy',
    SHORT_MONTH: 'MMM',
    ROUTINE_TEST_DATE: 'MMMM yyyy',
    APPOINTMENT_TIME: 'p',
    SCHEDULE_DATE: 'iii, dd MMM',
  },

  DONOR_CRITERIA: {
    // Weight
    MIN_BIG_DONOR_WEIGHT: 25, // in kgs
    MIN_DOG_WEIGHT_LBS: 44,
    MIN_DOG_WEIGHT_KG: 15.87,
    MIN_CAT_WEIGHT_LBS: 9.5,
    MIN_CAT_WEIGHT_KG: 4.3,
    MAX_CAT_WEIGHT_LBS: 60,
    MAX_CAT_WEIGHT_KG: 30,
    MAX_DOG_WEIGHT_LBS: 300,
    MAX_DOG_WEIGHT_KG: 140,

    EXPECTED_MLS_BIG_DONOR: 450,
    EXPECTED_MLS_SMALL_DONOR: 250,
    BLOOD_VOLUME_PER_KG: 85, // in mls
    BLOOD_VOLUME_PERCENTAGE: 20, // in mls

    DEFAULT_MIN_DONOR_AGE: 1, // in years
    MIN_CAT_AGE: 1, // in years
    MIN_DOG_AGE: 1, // in years

    DEFAULT_DONOR_RETIREMENT_AGE: 9, // in years
    CAT_RETIREMENT_AGE: 9, // in years
    DOG_RETIREMENT_AGE: 9, // in years
  },

  VALIDITY_PERIODS: {
    LABWORK_DURATION_DAYS: 365,
    DVM_EXAM_DURATION_DAYS: 365,
    LAST_LABWORK_LIMIT_DAYS: 350,
  },

  DEFAULTS: {
    VETERINARIAN: 'Melanie S. Galanis, DVM',
    CAPILLARY_REFILL_TIME: CapillaryRefillTime.BetweenOneAndTwo,
    MUCOUS_MEMBRANE: Mm.Pink,
    REGION_FILTRATION_ENABLED: true,
  },

  CHARTS: {
    DEFAULT_DONATIONS_LIMIT: 12,
    DATE_PICKER_FORMAT: 'yyyy/MM',
  },

  FEATURES: {
    APPOINTMENTS_PAGE_ENABLED: false,
    TASK_SCHEDULE_PAGE_ENABLED: false,
  },
};
